/**
 * Same as calling `Object.keys()` but with proper inferral
 */
export function getObjectKeys<T extends object>(obj: T): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>;
}
